import React, { FC } from 'react'
import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { createUseStyles } from 'react-jss'
import cx from 'classnames'
import { UserWithImages } from 'shared/src/api/types'

import rodeo_u from 'assets/rodeo_u.svg'
import avatarMask from 'assets/avatar-mask.svg'
import avatarDefault from 'assets/avatar-default.png'

interface StyleProps {
  height: number
}

const useStyles = createUseStyles({
  container: {
    position: 'relative',
    cursor: 'pointer',
    height: ({ height }: StyleProps) => height,
  },
  shadow: {
    position: 'absolute',
    height: ({ height }: StyleProps) => height,
    width: ({ height }: StyleProps) => height,
    filter: 'drop-shadow(0 0 5px black)',
  },
  avatar: {
    height: ({ height }: StyleProps) => height,
    aspectRatio: '1 / 1',
    maskImage: `url(${avatarMask})`,
    maskSize: 'cover',
    objectFit: 'cover',
  },
})

interface Props {
  creator: Pick<UserWithImages, 'username' | 'image' | 'collegeId'>
  shadow?: boolean
  noBadges?: boolean
  height?: number
  className?: string
}

export const Avatar: FC<Props> = flowMax(
  addDisplayName('Avatar'),
  addProps(({ height }) => ({
    classes: useStyles({ height: height ?? 48 }),
  })),
  ({
    creator: { username, image, collegeId },
    noBadges,
    shadow,
    classes,
    className,
  }) => (
    <div style={{ position: 'relative' }}>
      <div className={cx(classes.container, className)}>
        {shadow && <img src={avatarMask} alt="" className={classes.shadow} />}
        <img
          src={image?.thumbnail ?? avatarDefault}
          alt={username!}
          className={classes.avatar}
        />
      </div>
      <img
        src={rodeo_u}
        alt="rodeo u badge"
        style={{
          position: 'absolute',
          top: -4,
          right: -4,
          display: !collegeId || noBadges ? 'none' : 'flex',
          height: 16,
        }}
      />
    </div>
  )
)
